import type { UserNotificationType } from "common/types/userNotification";
import type { RefObject } from "react";
import { createContext, useContext } from "react";

export interface AppContextProps {
  modalContainerRef: RefObject<HTMLDivElement | null> | null;
  userNotification: UserNotificationType | null;
  setUserNotification: (arg0: UserNotificationType | null) => void;
  offline: boolean;
  setOffline: (offline: boolean) => void;
}

const AppContext = createContext<AppContextProps>({
  modalContainerRef: null,
  userNotification: null,
  setUserNotification: () => {},
  offline: false,
  setOffline: () => {},
});

AppContext.displayName = "AppContext";

export default function useAppContext(): AppContextProps {
  return useContext(AppContext);
}

export { AppContext };
